/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getBreakpoint = getBreakpoint;
/*
BreakpointController
--------------------
Helper functions to simplify listening for events related to crossing
responsive breakpoints. By listening for document cross_breakpoint instead of
window resize, we can cut down on the amount of code running/dom thrashing and
improve performance!

Use Case
========
You have a hamburger nav on SMALL viewports that uses slideToggle to show and
hide the navigation but displays normally on LARGE viewports. It’s possible
that the user might be viewing the page on a desktop browser with the window
sized down if the user closes the nav and resizes the browser to a width that
SHOULD display the nav normally. slideToggle’s inline display:none overrides
the stylesheets media query that should be display:block (or something
similar).

To fix this, we listen for the cross breakpoint event and clear out any inline
styles whenever we change from one to another.

--: nav-controller.example.js :-----------------------------------------------

import { CROSS_BREAKPOINT, LARGE } from './breakpoint-controller'

function enableMobileFunctionality(){ //blah blah blah hamburgers }
function enableDesktopFunctionality(){ //blah blah blah mega nav }

$(document).on(CROSS_BREAKPOINT, onCrossBreakpoint);

function onCrossBreakpoint(e, breakpoint) {
	$('.navigation').attr('style', "");

	if (breakpoint >= LARGE) {
		enableDesktopFunctionality();
	} else {
		enableMobileFunctionality();
	}
}
*/
var CROSS_BREAKPOINT = exports.CROSS_BREAKPOINT = 'cross_breakpoint';

/*JS_BREAKPOINT_EXPORTS*/
var XSMALL = exports.XSMALL = 400;
var SMALL = exports.SMALL = 600;
var MEDIUM = exports.MEDIUM = 800;
var LARGE = exports.LARGE = 1000;
var NAVIGATION = exports.NAVIGATION = 1000;
var XLARGE = exports.XLARGE = 1200;
/*END_JS_BREAKPOINT_EXPORTS*/

var $ = window.jQuery;

var win,
    currentBreakpoint = null,
    breakpoints = /*JS_BREAKPOINT_ARRAY*/
[XSMALL, SMALL, MEDIUM, LARGE, NAVIGATION, XLARGE]
/*END_JS_BREAKPOINT_ARRAY*/;

function onDocumentReady() {
	win = $(window);
	win.on({
		'resize': checkWindow,
		'load': checkWindow
	});
	setTimeout(checkWindow, 0);
}

function checkWindow() {
	var w = win.width(),
	    ret;

	for (var i = 0; i < breakpoints.length; i++) {
		var breakpoint = breakpoints[i];
		if (w >= breakpoint) {
			ret = breakpoint;
		} else {
			break;
		}
	}

	setBreakpoint(ret);
}

function setBreakpoint(breakpoint) {
	if (breakpoint !== currentBreakpoint) {
		$(document).trigger(CROSS_BREAKPOINT, [breakpoint]);
	}

	currentBreakpoint = breakpoint;
}

function getBreakpoint() {
	return currentBreakpoint;
}

document.addEventListener('DOMContentLoaded', onDocumentReady);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(2);

__webpack_require__(5);

__webpack_require__(0);

__webpack_require__(6);

__webpack_require__(7);

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(3);

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(4);

var _breakpointController = __webpack_require__(0);

var MOBILE = 'mobile';
var DESKTOP = 'desktop';
var DOUBLE_TAP_SELECTOR = '#main-menu .menu-item-top-level.menu-item-has-children';
var exitDelay = 250;
var enterDelay = 150;

var scrollY = 0;
var mode = MOBILE;
var open = false;

var body = null;
var mainMenu = null;
var activeItem = null;
var exitTimeout = null;
var enterTimeout = null;
var itemToOpen = null;

var $ = window.jQuery;

function onDocumentReady() {
    $(document).on(_breakpointController.CROSS_BREAKPOINT, onCrossBreakpoint);
    body = $(document.body);
    mainMenu = $('#main-menu');

    $('#main-menu-toggle').on('click', onClickMobileNavToggle);
    $(mainMenu).on('click', '.sub-menu-toggle', onClickSubMenuToggle);
}

function onClickSubMenuToggle(e) {
    var clicked = $(e.currentTarget);
    var item = clicked.closest('.menu-item');

    clicked.toggleClass('active');
    item.children('.sub-menu').slideToggle();
}

function onClickMobileNavToggle(e) {
    if (open) {
        closeMobileNav();
    } else {
        openMobileNav();
    }
}

function openMobileNav() {
    mainMenu.stop(true, true).show();
    scrollY = $(window).scrollTop();
    body.addClass('nav-open').addClass('noscroll').css({ top: -1 * scrollY });

    open = true;
}

function closeMobileNav() {
    mainMenu.stop(true, true).hide();
    body.removeClass('nav-open').removeClass('noscroll');
    $(window).scrollTop(scrollY);

    open = false;
}

function reset() {
    mainMenu.removeAttr('style');
    mainMenu.find('.menu-item-top-level').removeClass('active');
    mainMenu.find('.sub-menu').removeAttr('style');
    mainMenu.find('.sub-menu-toggle').removeClass('active');
    body.removeClass('nav-open').removeClass('noscroll');
    open = false;
}

function setMode(newMode) {
    if (newMode === mode) {
        return false;
    }

    mode = newMode;
    reset();

    switch (mode) {
        case MOBILE:
            mainMenu.off('mouseenter', '.menu-item-top-level', onMouseEnterTopLevelItem).off('mouseleave', '.menu-item-top-level', onMouseLeaveTopLevelItem);

            $(DOUBLE_TAP_SELECTOR).doubleTapToGo('unbind');
            break;

        case DESKTOP:
            mainMenu.on('mouseenter', '.menu-item-top-level', onMouseEnterTopLevelItem).on('mouseleave', '.menu-item-top-level', onMouseLeaveTopLevelItem);

            $(DOUBLE_TAP_SELECTOR).doubleTapToGo();

            break;
    }
}

function onMouseEnterTopLevelItem(e) {
    itemToOpen = $(e.currentTarget);

    clearTimeout(exitTimeout);
    clearTimeout(enterTimeout);
    enterTimeout = setTimeout(finishMouseEnterTopLevelItem, enterDelay);
}

function finishMouseEnterTopLevelItem() {
    setActiveItem(itemToOpen);
}

function onMouseLeaveTopLevelItem(e) {
    clearTimeout(exitTimeout);
    clearTimeout(enterTimeout);
    exitTimeout = setTimeout(clearActiveItem, exitDelay);
}

function clearActiveItem() {
    setActiveItem(null);
}

function setActiveItem(item) {
    if (item && activeItem && item.get(0) === activeItem.get(0)) {
        return false;
    }

    if (activeItem) {
        deactivateMenuItem(activeItem);
    }
    if (item) {
        activateMenuItem(item);
    } else {
        activeItem = null;
    }
}

function activateMenuItem(item) {
    item.addClass('menu-active');
    item.children('.sub-menu').stop(true, false);
    activeItem = item;
}

function deactivateMenuItem(item) {
    item.removeClass('menu-active');
    item.children('.sub-menu').stop(true, false);
}

function onCrossBreakpoint(e, breakpoint) {
    if (breakpoint >= _breakpointController.NAVIGATION) {
        setMode(DESKTOP);
    } else {
        setMode(MOBILE);
    }
}

document.addEventListener('DOMContentLoaded', onDocumentReady);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */
/*!
* jQuery Double Tap To Go - v1.0.0 - 2015-04-20
* http://github.com/zenopopovici/DoubleTapToGo
* Copyright (c) 2015 Graffino
*/
!function ($, window, document, undefined) {
  $.fn.doubleTapToGo = function (action) {
    return "ontouchstart" in window || navigator.msMaxTouchPoints || navigator.userAgent.toLowerCase().match(/windows phone os 7/i) ? (this.each("unbind" === action ? function () {
      $(this).off(), $(document).off("click touchstart MSPointerDown", handleTouch);
    } : function () {
      function handleTouch(e) {
        for (var resetItem = !0, parents = $(e.target).parents(), i = 0; i < parents.length; i++) {
          parents[i] == curItem[0] && (resetItem = !1);
        }resetItem && (curItem = !1);
      }var curItem = !1;$(this).on("click", function (e) {
        var item = $(this);item[0] != curItem[0] && (e.preventDefault(), curItem = item);
      }), $(document).on("click touchstart MSPointerDown", handleTouch);
    }), this) : !1;
  };
}(jQuery, window, document);

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadJS = loadJS;
exports.loadCss = loadCss;
exports.debounce = debounce;
exports.isElementInViewport = isElementInViewport;
/**
 * Asynchronously loads JavaScript
 * @param  {string}  url  JavaScript URL
 */
function loadJS(url) {
    var s = document.createElement('script');
    s.type = 'text/javascript';
    s.src = url;
    s.async = true;

    document.head.appendChild(s);
}

/**
 * Asynchronously loads CSS
 * @param  {string}  url  Stylesheet URL
 */
function loadCss(url) {
    var ss = document.styleSheets;

    for (var i = 0, max = ss.length; i < max; i++) {
        if (ss[i].href === url) {
            return;
        }
    }

    var l = document.createElement('link');
    l.type = 'text/css';
    l.rel = 'stylesheet';
    l.href = url;
    document.head.appendChild(l);
}

/**
 * Throttles taxing functions
 * https://davidwalsh.name/javascript-debounce-function
 *
 * @param  {function}  func       Function you want to run
 * @param  {integer}   wait       Milliseconds to wait before calling function
 * @param  {boolean}   immediate  If true, trigger function on the leading edge, instead of the trailing
 */
function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this,
            args = arguments;
        var later = function later() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

/**
 * Checks if an element in the viewport
 * @param  {object}  el Element
 * @return {boolean}    The element is/isn't in the viewport
 */
function isElementInViewport(el) {

    // If a jQuery object has been passed
    if (typeof jQuery === 'function' && el instanceof jQuery) {
        el = el[0];
    }

    var rect = el.getBoundingClientRect();

    return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
    rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
    ;
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var grunticonController = function () {
    var ret = {},
        svgPath,
        pngPath,
        fallbackPath;

    function doGrunticon() {
        svgPath = SiteInfo.grunticonPath + 'icons.data.svg.css';
        pngPath = SiteInfo.grunticonPath + 'icons.data.png.css';
        fallbackPath = SiteInfo.grunticonPath + 'icons.fallback.css';

        grunticon([svgPath, pngPath, fallbackPath], function () {
            grunticon.svgLoadedCORSCallback();
        });
    }

    document.addEventListener('DOMContentLoaded', doGrunticon);

    ret = {
        doGrunticon: doGrunticon
    };

    return ret;
}();

exports.default = grunticonController;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _breakpointController = __webpack_require__(0);

var $ = window.jQuery;
var header = void 0,
    win = void 0;
var paddingTop, target, scrollTarget;

function onDocumentReady() {
    win = $(window);
    header = $('#header');
    paddingTop = 120;
    win.on('load scroll', function () {
        if (win.width() >= _breakpointController.LARGER) {
            if ($(this).scrollTop() >= 50) {
                header.addClass('header-sticky');
            } else {
                header.removeClass('header-sticky');
            }
        }
    });
}

$(onDocumentReady);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main.js